import React from 'react';
import { Box, Group, Text } from '@mantine/core';
import { IconInfoCircle } from '@tabler/icons-react';

export function SuggestedPriceCostFloorCallout() {
    return (
        <Box className="rounded-lg border border-[#e6e9ef] bg-white p-3">
            <Group gap={10} align="flex-start" wrap="nowrap">
                <IconInfoCircle
                    size={15}
                    className="mt-0.5 shrink-0 text-primary"
                    aria-hidden
                />
                <Text size="xs" c="dimmed" lh={1.65}>
                    <Text span size="xs" fw={600} c="primary">
                        Cost floor, then Cashbuild ending.
                    </Text>{' '}
                    If the result falls below cost (ex VAT) + VAT, that minimum
                    is used instead (rounded up to{' '}
                    <Text span size="xs" fw={600} c="primary">
                        .99
                    </Text>{' '}
                    for Bricks or{' '}
                    <Text span size="xs" fw={600} c="primary">
                        .95
                    </Text>{' '}
                    otherwise). Finally, every suggestion is rounded{' '}
                    <Text span size="xs" fw={600} c="primary">
                        down
                    </Text>{' '}
                    to the next Cashbuild ending (
                    <Text span size="xs" fw={600} c="primary">
                        .99
                    </Text>{' '}
                    Bricks /{' '}
                    <Text span size="xs" fw={600} c="primary">
                        .95
                    </Text>{' '}
                    other) — without going below the cost floor.
                </Text>
            </Group>
        </Box>
    );
}
